module.exports = __webpack_public_path__ + "LatoLatin-Heavy.913305344fd127206274.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Heavy.woff2
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Heavy.woff2
// module chunks = styles